import type { OptionsVisibility } from '@atlassian/ui-modifications-core/types';

import { validateSetOptionsVisibilityRule } from '@atlassian/ui-modifications-public-api-utils/options-visibility';

export const optionsVisibilityContainNoMoreThan100Items = (optionsVisibility: OptionsVisibility) =>
    optionsVisibility.options.length <= 100;

export const validateSetOptionsVisibility = (optionsVisibility: OptionsVisibility): boolean =>
    validateSetOptionsVisibilityRule(optionsVisibility) &&
    optionsVisibilityContainNoMoreThan100Items(optionsVisibility);
